interface FieldContainerParams {
    children: React.ReactNode;
}
export const FieldContainer = ({ children }: FieldContainerParams) => {
    return <div style={{ margin: '8px 0 12px 0' }}>{children}</div>
}